export const ENCRYPTION_API_URL =
  'https://encrypt-decrypt-api.dl-dotcom-ux-dev.pub.delta.com/encrypt';
export const DECRYPTION_API_URL =
  'https://encrypt-decrypt-api.dl-dotcom-ux-dev.pub.delta.com/decrypt';
export const DEFAULT_TIMEOUT = 10000;
